import React, { useEffect, useState } from "react";
import AddSalary from './add-salary';
import EditSalary from './edit-salary';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Button from '@mui/material/Button';
import moment from 'moment';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableContainer from '@mui/material/TableContainer';
import TablePagination from '@mui/material/TablePagination';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';


export default function Salary() {
    const [addSalaryOpen, setAddSalaryOpen] = useState(false);
    const [editSalaryOpen, setEditSalaryOpen] = useState(false);
    const [startDate, setStartDate] = useState(moment().format("YYYY-MM-DD"));
    const [endDate, setEndDate] = useState(moment().format("YYYY-MM-DD"));
    const [workerFilter, setWorkerFilter] = useState("all");
    const [editedSalaryId, setEditedSalaryId] = useState("");
    const [availableWorkers, setAvailableWorkers] = useState([]);
    const [salariesList, setSalariesList] = useState([]);
    const api_url = process.env.REACT_APP_API_URL;
    const complexName = localStorage.getItem('complex_name');
    const [totalSalary, setTotalSalary] = useState(0);
    const role = localStorage.getItem('role');
    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(25);

    const handleAddSalaryOpen = () => setAddSalaryOpen(true);
    const handleAddSalaryClose = () => setAddSalaryOpen(false);

    const handleEditSalaryOpen = () => setEditSalaryOpen(true);
    const handleEditSalaryClose = () => setEditSalaryOpen(false);

    function showEditSalaryModal(salary_id){
        handleEditSalaryOpen();
        setEditedSalaryId(salary_id);
    }


    function showAddSalaryModal(){
        handleAddSalaryOpen();
    }

    React.useEffect(() => {                                         //функция, которая вызывается при загрузке страницы
        async function getAvailableWorkers() {      //получаем список всех доступных сотрудников
            const requestOptions = {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Authorization': localStorage.getItem('token') },
              body: JSON.stringify({ complex_name: complexName })
            };
            const availableWorkers = await (await fetch(api_url+"/api/allLiveWorkers", requestOptions)).json();
            setAvailableWorkers(availableWorkers.map(({worker_id, full_name, rank, phone_number, complex_name, role}) => ({workerId: worker_id, fullName: full_name, rank: rank, phoneNumber: phone_number, complexName: complex_name, role: role})));
        }
    
        async function getSalaries() {
          setLoading(true);
          const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': localStorage.getItem('token')},
            body: JSON.stringify({ start_date: startDate, end_date: endDate, worker_id: workerFilter, complex_name: complexName})
          };
          try {
            const salaries_list = await fetch(api_url+"/api/allSalaries", requestOptions);
            const body = await salaries_list.json();
            setSalariesList(body.map(({ salary_id, salary_date, worker_id, full_name, salary_amount, complex_name, comment, created_by }) => ({ salary_id: salary_id, salary_date: new Date(salary_date).toLocaleString("ru-RU", { timeZone: "UTC" }), worker_id: worker_id, worker_name: full_name, salary_amount: salary_amount, complex_name: complex_name, comment: comment, created_by: created_by })));
            let temp_total_salary = 0;

            for(var i=0; i < body.length; i++){
               temp_total_salary = temp_total_salary + body[i].salary_amount;
            }

            setTotalSalary(temp_total_salary);
          } finally {
            setLoading(false);
          }
        }
        getAvailableWorkers();
        getSalaries();
    
        }, [startDate, endDate, workerFilter, addSalaryOpen, editSalaryOpen]);

    return (
        <>
            <Box sx={{pt:5, pb:5}} fullWidth>
            <TextField
                id="start_date"
                label="Дата с"
                type="date"
                defaultValue={startDate}
                sx={{ m: 1.5, width: 220}}
                InputLabelProps={{
                    shrink: true,
                }}
                onChange={e => { setStartDate(e.target.value); setPage(0); }}
            />

            <TextField
                id="end_date"
                label="Дата по"
                type="date"
                defaultValue={endDate}
                sx={{ m: 1.5, width: 220 }}
                InputLabelProps={{
                    shrink: true,
                }}
                onChange={e => { setEndDate(e.target.value); setPage(0); }}
            />

            <FormControl sx={{m: 1.5, width: 250}} >
            <InputLabel id="demo-simple-select-label">Выберите сотрудника</InputLabel>
            <Select
                id="worker_name"
                value={workerFilter}
                label="Выберите сотрудника"
                onChange={e => { setWorkerFilter(e.target.value); setPage(0); }}
            >
            <MenuItem value="all">Любой</MenuItem>
            {availableWorkers.map((item) => (
            <MenuItem key={item.workerId} value={item.workerId}>{item.fullName}</MenuItem>
            ))}
            </Select>
            </FormControl>
            </Box>


            {/* отображается админу и супер админу, но не hr-директору (роли 1 и 2) */}
            {(role === "1" || role === "2") && 
            <button className='add-visit-button' onClick={() => showAddSalaryModal()}>
            <a>Добавить выплату ЗП</a>
            </button>}

            <Typography m={5} variant="h6">ЗП за выбранный период: {totalSalary}</Typography>
            

            <TableContainer component={Paper} sx={{ maxHeight: 640 }}>
            <Table stickyHeader sx={{ minWidth: 650 }} aria-label="salaries table">
            <TableHead>
            <TableRow>
                <TableCell>Дата</TableCell>
                <TableCell>Сотрудник</TableCell>
                <TableCell align="right">Размер выплаты</TableCell>
                <TableCell>Комментарий</TableCell>
                <TableCell>Добавил</TableCell>
                <TableCell></TableCell>
            </TableRow>
            </TableHead>
            <TableBody>
            {loading ? (
                <TableRow>
                    <TableCell colSpan={6} align="center" sx={{ py: 6 }}><CircularProgress size={28} /></TableCell>
                </TableRow>
            ) : salariesList.length === 0 ? (
                <TableRow>
                    <TableCell colSpan={6} align="center" sx={{ py: 6, color: 'text.secondary' }}>Нет выплат за выбранный период</TableCell>
                </TableRow>
            ) : salariesList.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(({salary_date, salary_id, worker_name, salary_amount, comment, created_by}) => (
            <TableRow key={salary_id} hover>
                <TableCell>{salary_date}</TableCell>
                <TableCell>{worker_name}</TableCell>
                <TableCell align="right">{salary_amount}</TableCell>
                <TableCell sx={{whiteSpace: "normal", wordWrap: "break-word"}}>{comment}</TableCell>
                <TableCell>{created_by || '-'}</TableCell>
                <TableCell>
                <Button
                    variant="outlined"
                    onClick={() => showEditSalaryModal(salary_id)}>Изменить</Button>
                </TableCell>
            </TableRow>
            ))}
            </TableBody>
            </Table>
            </TableContainer>
            {!loading && salariesList.length > 0 && (
            <TablePagination
                component="div"
                count={salariesList.length}
                page={page}
                onPageChange={(e, p) => setPage(p)}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={(e) => { setRowsPerPage(parseInt(e.target.value, 10)); setPage(0); }}
                rowsPerPageOptions={[10, 25, 50, 100]}
                labelRowsPerPage="Строк на странице:"
            />
            )}


            <Modal
            open={addSalaryOpen}
            onClose={handleAddSalaryClose}
            >
            <AddSalary availableWorkers={availableWorkers}/>
            </Modal>

            <Modal
            open={editSalaryOpen}
            onClose={handleEditSalaryClose}
            >
            <EditSalary editedSalaryId={editedSalaryId} availableWorkers={availableWorkers}/>
            </Modal>
        </>
    )
}

